/* eslint-disable */

// Opera 8.0+
const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
const isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;

// Chrome 1+
const isChrome = !!window.chrome && !!window.chrome.webstore;

// Blink engine detection
const isBlink = (isChrome || isOpera) && !!window.CSS;

export const getBrowserName = () => {
    if(isOpera) {
        return 'Opera'
    } else if (isFirefox) {
        return 'Firefox'
    } else if (isSafari) {
        return 'Safari'
    } else if (isIE) {
        return 'Internet Explorer'
    } else if (isEdge) {
        return 'Edge'
    } else if (isChrome) {
        return 'Chrome'
    } else if (isBlink) {
        return 'Blink'
    } else {
        return 'Unknown'
    }
};


// WEBPACK FOOTER //
// ./src/services/BrowserService.js